import {ActivityType} from '@lib/infrastructure';
import {TFunction} from 'i18next';
import {constructFilter} from './constructFilter';

export const SECTION_ID_ACTIVITY_TYPE = 'SECTION_ID_ACTIVITY_TYPE';

export const constructActivityTypeFilter = <TEntity extends {activityTypes: ActivityType[]}>(
  availableActivityTypes: ActivityType[],
  t: TFunction,
) => {
  return constructFilter({
    sectionId: SECTION_ID_ACTIVITY_TYPE,
    sectionTitle: t('workplace:ActivityTypesFilterSectionTitle'),
    type: 'and',
    data: availableActivityTypes.map((id) => ({
      id,
      label: t(`activityTypes:activityType`, {context: id}),
    })),
    defaultFilterOptions: [],
    predicate: (filter, entity: TEntity) => entity.activityTypes.includes(filter.id),
  });
};
